import React from "react"
import { Helmet } from "react-helmet"
import { Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import List from "./List"
function ReportList() {
  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "List",
      link: "/report/list",
    },
    paths: [
      {
        label: "Report",
        link: "/report/list",
      },
    ],
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Report List | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />

          <List />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ReportList
